import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-24">
      <div className="text-center">
        <p className="section-label mb-3">Error 404</p>
        <h1 className="serif-display text-6xl md:text-8xl text-foreground gold-text">Not Found</h1>
        <p className="mt-4 text-foreground/70 max-w-md mx-auto">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="mt-8 inline-block">
          <Button className="rounded-sm h-11 bg-gold hover:bg-gold-400 text-navy-900 font-semibold tracking-wider uppercase text-xs px-6">
            <Home size={14} className="mr-2" /> Back to Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
